import React from "react"
import { ButtonProps } from "dash-styled"
import { useJobIdToReview } from "../../../../../../Hooks/useJobIdToReview"
import { routePaths } from "../../../../../../Routes"
import { SortExpression } from "../../../../../../Models/Client/SortExpression"
import { APIJobQueryModel } from "../../../../../../Models/API/JobModel"
import { NavButton } from "../../../../../Common/NavButton/NavButton"
import { hasValue } from "../../../../../../Models/Client/FetchState"

type ReviewUnreviewedButtonProps = Omit<ButtonProps, "onClick" | "disabled"> & {
    orgUsername: string
    appID: string
    sort?: SortExpression<APIJobQueryModel>
    disabledClassName?: string
}

export function ReviewUnreviewedButton({
    orgUsername,
    appID,
    sort,
    disabledClassName,
    className,
    ...buttonProps
}: ReviewUnreviewedButtonProps) {
    const jobToReview = useJobIdToReview(appID)
    const disabled =
        !hasValue(jobToReview) || jobToReview.value === "nothing_to_review"

    return (
        <NavButton
            to={routePaths.appDetailReviewJobs(orgUsername, appID, sort)}
            disabled={disabled}
            className={`${disabled ? disabledClassName : ""} ${
                className ?? ""
            }`}
            {...buttonProps}
        />
    )
}
